/**
 * @desc 根据包裹单号获取订单包裹
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageItemFacadeImpl.getPackageByOpNo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/systemOrderPackage/getPackageByOpNo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
